<template>
<div>
    <h3>Cultural Resource Group <b>{{this.crr.smithsonianNumber}}</b></h3>
    <h4></h4>
    <loader v-show="isLoading"/>
    <div v-show="!isLoading">
        <div v-if="isEmptyGroup">
            <div class="alert alert-info" role="info">
                <strong>This Cultural Resource is not currently a part of any Cultural Resource Group</strong>
                <br />
                Either create a new group, or add it to an existing group
                <br/><br/><br/>
                <div class="row">
                    <button class="btn btn-primary" v-on:click="createGroup()">Create New Group</button>
                    <button class="btn btn-primary" v-on:click="addToExistingGroupSearch()">Add To Existing Group</button>
                </div>
            </div>
        </div>
        <div v-else class="row">
            <div class="col-lg-4">
                <div class="panel panel-offset">
                    <div class="panel-heading green-bg">
                        <h3 class="panel-title">Heads</h3>
                    </div>
                    <div v-if="groupHeadList.length > 0" class="panel-body">
                        <!-- <h4>{{groupHeadList.siteName}}</h4>
                        <div class="form-group">
                            <label class="col-md-4 control-label text-label">Smithsonian Number</label>
                            <div class="col-md-8 text-label">
                                {{groupHeadList.smithsonianNumber}}
                            </div>
                        </div>
                        <div class="form-group" v-if="productionAdminEdit">
                            <button class="btn btn-primary" v-show="isEdit" v-on:click="removeHead()">Remove Head</button>
                        </div> -->
                        <div>
                            <v-client-table :data="groupHeadList" :columns="headGridSpec.columns" :options="headGridSpec.options">
                                <template slot="remove" slot-scope="props">
                                    <div style="text-align: center" v-if="isEdit">
                                        <a class="fa fa-remove" style="font-size: 18px;" v-on:click="removeHead(props.row.culturalResourceId)"></a>
                                    </div>
                                </template>
                            </v-client-table>
                        </div>
                    </div>
                    <div v-else class="panel-body">
                        <div class="alert alert-info" role="info">
                            <div class="text-label">
                                There is no head for this group
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-8">
                <div class="panel panel-offset">
                    <div class="panel-heading green-bg">
                        <h3 class="panel-title">Members</h3>
                    </div>
                    <div class="panel-body">
                        <div v-if="memberList.length > 0">
                            <v-client-table :data="memberList" :columns="memberGridSpec.columns" :options="memberGridSpec.options">
                                <template slot="memberType" slot-scope="props">
                                    <div >{{props.row.segment > 0 ? 'Segment' : 'Member'}}</div>
                                </template>
                                <template slot="addHead" slot-scope="props">
                                    <div style="text-align: center" v-show="isEdit">
                                        <button v-if="props.row.segment < 1" class="btn" v-on:click="setHead(props.row.culturalResourceGroupId)">Add to Head</button>
                                    </div>
                                </template>
                                <template slot="addAnotherGroup" slot-scope="props">
                                    <div style="text-align: center" v-if="isEdit">
                                       <button class="btn" v-on:click="addToDifferentGroup(props.row)">Add to another group</button>
                                    </div>
                                </template>
                                <template slot="remove" slot-scope="props">
                                    <div style="text-align: center" v-show="isEdit">
                                       <a class="fa fa-remove" style="font-size: 18px;" v-on:click="removeMemberFromGroup(props.row.culturalResourceGroupId)"></a>
                                    </div>
                                </template>
                            </v-client-table>
                        </div>
                        <div class="alert alert-info" role="info" v-else >
                            <div class="text-label">
                                There are no members for this group
                            </div>
                        </div>
                        <div style="margin-top: 10px;">
                            <button class="btn btn-primary" v-on:click="showSearch()" v-show="isEdit">Add Member</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <modal ref="culturalResourceSearchModal">
        <h3 slot="header">Cultural Resource Search</h3>
        <div slot="body">
            <culturalResourceSearch :addCulturalResource="addMemberToGroup" :resultFilter="filterExisting" />
        </div>
    </modal>
    <modal ref="headSearchModal">
        <h3 slot="header">Cultural Resource Search</h3>
        <div slot="body">
            <culturalResourceSearch :addCulturalResource="addToGroup" :resultFilter="filterHasResourceId" />
        </div>
    </modal>
    <div v-show="culturalResourceRecordingId">
            <button class="btn btn-primary" v-on:click="goRecording()">{{ productionAdminEdit? 'Return to Production Record' : 'Return to Recording' }}</button>
    </div>
</div>
</template>

<script>
import culturalResourceService from '@/services/culturalResourceService'
import culturalResourceGroupService from '@/services/culturalResourceGroupService'
import culturalResourceRecordingService from '@/services/culturalResourceRecordingService'
import loggingService from '@/services/util/loggingService'
import modal from '@/components/Modal.vue'
import culturalResourceSearch from '@/components/CulturalResourceSearch.vue'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
import { mapState } from 'vuex'
import loader from '../components/Loader.vue'

export default {
    name: 'culturalResourceGroup',
    components: {
        modal,
        culturalResourceSearch,
        loader
    },
    data: function () {
        return {
            isDebug: false,
            pageMode: '',
            isLoading: false,
            groupHeadList: [],
            memberList: [],
            groupList: [],
            culturalResourceHeadId: this.$route.query.culturalResourceHeadId,
            culturalResourceRecordingId: this.$route.query.culturalResourceRecordingId,
            culturalResourceId: this.$route.query.culturalResourceId,
            resourceId: this.$route.query.resourceId,
            isCrrProduction: false,
            crr: {},
            culturalResource: {},
            headGridSpec: {
                columns: ['siteName', 'smithsonianNumber', 'remove'],
                options: {
                    perPage: 10,
                    perPageValues: [5, 10, 25],
                    headings: {
                        smithsonianNumber: 'Smith No',
                        siteName: 'Site Name',
                        add: 'Remove Head'
                    }
                }
            },
            memberGridSpec: {
                columns: ['siteName', 'smithsonianNumber', 'memberType', 'addHead', 'addAnotherGroup', 'remove'],
                options: {
                    perPage: 10,
                    perPageValues: [5, 10, 25],
                    headings: {
                        smithsonianNumber: 'Smith No',
                        siteName: 'Site Name',
                        memberType: 'Member Type',
                        remove: 'Remove',
                        addHead: '',
                        addAnotherGroup: ''
                    },
                    orderBy: {
                        column: 'memberType'
                    }
                }
            },
            selectedCrIdToAddToGroup: null
        }
    },
    computed: {
        isEmptyGroup: function () {
            return !this.resourceId || (!this.isLoading && this.memberList.length === 0 && this.groupHeadList.length < 1)
        },
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        checkAdminRole: function () {
            var shpoRoleList = [
                roleService.RoleEnum.Administrator,
                roleService.RoleEnum.ShpoAdministrator
            ]
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, shpoRoleList))
        },
        isEdit: function () {
            // if ((this.$route.query.isEdit == null || this.$route.query.isEdit === 'true') && !this.isCrrProduction) {
            //     return true
            if (this.productionAdminEdit && this.$route.query.isEdit) {
                return true
            }
            return false
        },
        productionAdminEdit: function () {
            return this.$route.query.prod && this.checkAdminRole && this.isCrrProduction
        }
    },
    mounted () {
        this.loadData().then(result => {
            this.log('Done loading data. IsEmpty: ' + this.isEmptyGroup)
            this.log('culturalResourceRecordingId:' + this.culturalResourceRecordingId)
        })
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'CulturalResourceGroup', message)
        },
        loadMembers () {
            return new Promise((resolve, reject) => {
                if (this.resourceId) {
                    var searchDto = { resourceId: this.resourceId, showInactive: true }
                    return culturalResourceService.search(this.$http, searchDto).then(result => {
                        this.memberList = result.data
                        this.log('Member list now ' + this.memberList.length)
                        resolve(result)
                    })
                } else {
                    resolve(1)
                }
            })
        },
        loadGroup () {
            this.log('loading group')
            return new Promise((resolve, reject) => {
                if (this.resourceId) {
                    var searchDto = {resourceId: this.resourceId}
                    return culturalResourceGroupService.search(this.$http, searchDto).then(result => {
                        this.log('found results, count:' + result.data.length)
                        this.groupList = result.data
                        resolve(result)
                    })
                } else {
                    resolve(1)
                }
            })
        },
        loadCrr () {
            return culturalResourceRecordingService.get(this.$http, this.culturalResourceRecordingId, false).then(result => {
                this.crr = result.data
                this.isCrrProduction = result.data.isProduction
                return
            })
        },
        loadCr () {
            return culturalResourceService.get(this.$http, this.culturalResourceId).then(result => {
                this.culturalResource = result.data
                if (!this.resourceId) {
                    this.resourceId = this.culturalResource.resourceId
                }
                return
            })
        },
        loadData () {
            this.log('Loading data')
            this.isLoading = true
            //reseting data
            this.groupHeadList = []
            return Promise.all([this.loadCr(), this.loadCrr()]).then(res1 => {
                return Promise.all([this.loadCr(), this.loadCrr(), this.loadMembers(), this.loadGroup()]).then(result => {
                    var headGroupRecord = this.groupList.filter(groupRecord => { return groupRecord.groupMemberTypeId === 1 })
                    if (headGroupRecord && headGroupRecord.length > 0) {
                        this.groupHeadList = this.memberList.filter(cr => { return headGroupRecord.some(x => cr.culturalResourceId === x.culturalResourceMemberId) })
                        this.memberList = this.memberList.filter(cr => { return !headGroupRecord.some(x => cr.culturalResourceId === x.culturalResourceMemberId) })
                    }
                    //Set the culturalResourceGroup so a CR can tie back it its culturalResourceGroup record
                    this.memberList.forEach(cr => {
                        var group = this.groupList.find(x => x.culturalResourceMemberId === cr.culturalResourceId)
                        cr.culturalResourceGroupId = (group) ? group.culturalResourceGroupId : 0
                    })
                    //Sort by smith number, then by segment
                    this.memberList.sort(function (a, b) {
                        if (a.smithsonianNumber < b.smithsonianNumber) {
                            return -1
                        }
                        if (a.smithsonianNumber > b.smithsonianNumber) {
                            return 1
                        }
                        if (a.segment && b.segment) {
                            return a.segment < b.segment
                        } else {
                            return a.segment || b.segment
                        }
                    })
                    this.log('Head: ' + this.groupHeadList && this.groupHeadList.length > 0)
                    this.log('Member Count: ' + this.memberList.length)
                    this.isLoading = false
                    return result
                })
            })
        },
        showSearch () {
            this.$refs['culturalResourceSearchModal'].open()
        },
        addMemberToGroup (culturalResource) {
            this.log('Adding member to group: ' + culturalResource.culturalResourceId)
            var culturalResourceGroupDto = {
                culturalResourceGroupTypeId: this.culturalResourceGroupTypeId,
                culturalResourceHeadId: this.culturalResourceHeadId,
                culturalResourceMemberId: culturalResource.culturalResourceId
            }
            // if this isn't an admin edit, save to group change, else save directly
            //deprecated: group change is not being used
            // if (!this.productionAdminEdit) {
            //     culturalResourceGroupDto.operationType = 1
            //     culturalResourceGroupDto.culturalResourceRecordingId = this.culturalResourceRecordingId
            //     culturalResourceGroupService.putChange(this.$http, culturalResourceGroupDto).then(result => {
            //         this.$refs['culturalResourceSearchModal'].close()
            //         this.loadData()
            //     })
            // } else

            //set memberTypeId to member
            culturalResourceGroupDto.groupMemberTypeId = 2
            culturalResourceGroupDto.resourceId = this.resourceId
            culturalResourceGroupService.put(this.$http, culturalResourceGroupDto).then(result => {
                this.$refs['culturalResourceSearchModal'].close()
                this.loadData()
            })
        },
        removeMemberFromGroup (culturalResourceGroupId) {
            this.log('Remove member from group: ' + culturalResourceGroupId)
            culturalResourceGroupService.remove(this.$http, culturalResourceGroupId).then(result => {
                this.loadData()
            })
        },
        goRecording () {
            if (this.productionAdminEdit) {
                this.$router.push('/CulturalResource/' + this.culturalResourceId)
            } else {
                this.$router.push('/CulturalResourceRecording/' + this.$route.query.culturalResourceRecordingId)
            }
        },
        createGroup () {
            var crHeadId = this.$route.query.culturalResourceId
            this.log('Creating a group: ' + crHeadId)
            var groupDto = {
                culturalResourceMemberId: crHeadId,
                groupMemberTypeId: 2
            }
            culturalResourceGroupService.put(this.$http, groupDto).then(result => {
                if (result.data.isValid) {
                    var crGroup = result.data.objectList[0]
                    this.resourceId = crGroup.resourceId
                    this.$router.replace({name: 'CulturalResourceGroup', query: {...this.$route.query, resourceId: crGroup.resourceId}})
                    this.loadData()
                }
            })
        },
        addToExistingGroupSearch () {
            this.selectedCrIdToAddToGroup = this.culturalResourceId
            this.$refs['headSearchModal'].open()
        },
        filterExisting (searchResult) {
            this.log(`Filtering Existing ${searchResult.length} against memberList ${this.memberList.length} `)
            var filteredResults = searchResult.filter(cr => {
                return !this.memberList.some(member => member.culturalResourceId === cr.culturalResourceId) &&
                    !this.groupHeadList.some(h => cr.culturalResourceId === h.culturalResourceId)
            })
            this.log('Result size after filter: ' + filteredResults.length)
            return filteredResults
        },
        setHead (groupId) {
            this.log(`setting ${groupId} as head`)
            var selectedCr = this.memberList.find(x => { return x.culturalResourceGroupId === groupId })
            if (selectedCr.segment > 0) {
                this.log('Cannot select a segment to set to Head, crId selected: ' + selectedCr.culturalResourceId)
                return
            }
            var groupMember = this.groupList.find(x => { return x.culturalResourceGroupId === groupId })
            groupMember.groupMemberTypeId = 1
            var promises = [culturalResourceGroupService.put(this.$http, groupMember)]

            Promise.all(promises).then(result => {
                this.loadData()
            })
        },
        removeHead (crId) {
            var groupHead = this.groupList.find(x => { return x.culturalResourceMemberId === crId })
            if (groupHead) {
                groupHead.groupMemberTypeId = 2
                culturalResourceGroupService.put(this.$http, groupHead).then(result => {
                    this.loadData()
                })
            }
        },
        addToGroup (culturalResource) {
            this.log('Adding member to group: ' + culturalResource.culturalResourceId)
            if (!this.selectedCrIdToAddToGroup || !culturalResource.resourceId) {
                alert(`invalid ResourceId: ${culturalResource.resourceId} or member selection.  Cannot add/move to group`)
                return
            }
            var culturalResourceGroupDto = {
                culturalResourceMemberId: this.selectedCrIdToAddToGroup,
                resourceId: culturalResource.resourceId,
                groupMemberTypeId: 2
            }
            culturalResourceGroupService.put(this.$http, culturalResourceGroupDto).then(result => {
                this.$refs['headSearchModal'].close()
                this.loadData()
            })
        },
        addToDifferentGroup (member) {
            this.selectedCrIdToAddToGroup = member.culturalResourceId
            this.$refs['headSearchModal'].open()
        },
        filterHasResourceId (list) {
            this.log('filter for has resourceId')
            var filteredResults = list.filter(cr => { return !!cr.resourceId })
            //console.log(filteredResults)
            return filteredResults
        }
    }
}
</script>



// WEBPACK FOOTER //
// CulturalResourceGroup.vue?37aced0d